// client/src/components/configuracoes/disponibilidade/AgendaShareable.js

import React, { useMemo } from 'react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const AgendaShareable = React.forwardRef(({ itemSelecionado, data, horarios, accountName }, ref) => {
    
    const horariosPorTurno = useMemo(() => {
        const turnos = { manha: [], tarde: [], noite: [] };
        if (!horarios) return turnos;
        const horariosLivres = horarios.filter(h => h.status === 'Livre');
        horariosLivres.forEach(slot => {
            const hora = parseInt(slot.horario.split(':')[0], 10);
            if (hora < 12) turnos.manha.push(slot);
            else if (hora < 18) turnos.tarde.push(slot);
            else turnos.noite.push(slot);
        });
        return turnos;
    }, [horarios]);

    // Objeto de estilos inline que desenha o visual do "Story"
    // Este método garante que nenhum estilo externo do seu SCSS interfira na imagem final.
    const styles = {
        container: { width: '1080px', height: '1920px', padding: '80px', backgroundColor: '#1e3a8a', color: 'white', display: 'flex', flexDirection: 'column', fontFamily: 'sans-serif', boxSizing: 'border-box' },
        header: { textAlign: 'center', marginBottom: '40px' },
        title: { fontSize: '72px', fontWeight: 'bold', margin: 0, textTransform: 'uppercase', letterSpacing: '2px' },
        subtitle: { fontSize: '48px', opacity: 0.8, marginTop: '10px' },
        date: { textAlign: 'center', fontSize: '54px', fontWeight: '600', backgroundColor: 'rgba(255,255,255,0.1)', padding: '20px', borderRadius: '20px', marginBottom: '40px' },
        turnoRow: { display: 'flex', flexDirection: 'row', alignItems: 'center', paddingBottom: '20px', marginBottom: '20px', borderBottom: '2px solid rgba(255, 255, 255, 0.2)' },
        turnoTituloWrapper: { width: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
        turnoTitulo: { transform: 'rotate(-90deg)', whiteSpace: 'nowrap', fontSize: '42px', fontWeight: '300', textTransform: 'uppercase', letterSpacing: '3px', opacity: 0.7 },
        gridContainer: { flexGrow: 1 },
        grid: { display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '15px', textAlign: 'center' },
        slot: { backgroundColor: '#16a34a', color: 'white', padding: '15px 10px', borderRadius: '15px', fontSize: '38px', fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center' },
        footer: { marginTop: 'auto', textAlign: 'center', opacity: 0.7, fontSize: '36px', paddingTop: '40px' }
    };

    const nomeExibido = itemSelecionado?.nome || 'Horários Disponíveis';
    const dataFormatada = data ? format(new Date(data + 'T12:00:00Z'), "eeee, dd 'de' MMMM", { locale: ptBR }) : 'Data não informada';
    
    const renderTurno = (titulo, horariosDoTurno, isLast = false) => {
        if (horariosDoTurno.length === 0) return null;
        const turnoRowStyle = {...styles.turnoRow};
        if(isLast) { turnoRowStyle.borderBottom = 'none'; turnoRowStyle.marginBottom = 0; }
        return (
            <div style={turnoRowStyle}>
                <div style={styles.turnoTituloWrapper}><h3 style={styles.turnoTitulo}>{titulo}</h3></div>
                <div style={styles.gridContainer}>
                    <div style={styles.grid}>
                        {horariosDoTurno.map(h => (<div key={h.horarioISO} style={styles.slot}>{h.horario}</div>))}
                    </div>
                </div>
            </div>
        );
    };
    
    const turnosParaRenderizar = [
        { titulo: 'Manhã', horarios: horariosPorTurno.manha },
        { titulo: 'Tarde', horarios: horariosPorTurno.tarde },
        { titulo: 'Noite', horarios: horariosPorTurno.noite }
    ].filter(turno => turno.horarios.length > 0);

    return (
        <div ref={ref} style={styles.container}>
            <div style={styles.header}>
                <p style={styles.title}>Agenda Aberta!</p>
                <p style={styles.subtitle}>{nomeExibido}</p>
            </div>
            <p style={styles.date}>{dataFormatada}</p>
            
            {turnosParaRenderizar.map((turno, index) => 
                renderTurno(turno.titulo, turno.horarios, index === turnosParaRenderizar.length - 1)
            )}

            <div style={styles.footer}>
                <p>{accountName}</p>
            </div>
        </div>
    );
});

export default AgendaShareable;